import { useLayoutEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

import { ScreenSize, useScreenSize } from '@/ui/hooks/useScreenSize';
import { Col } from 'react-bootstrap';

import { useAppSelector } from '@/ui/store/helperRedux';

import MenuController from '@/controllers/MenuController';
import { IMenu } from '@/domain/interfaces/IMenu';

import { getCSSVariableValue } from '@/domain/utils/CssExtractVariable';
import { translate } from '@/domain/utils/translate';

import DropDownList from '@/ui/components/DropDownList';
import IconList from '@/ui/components/IconList';


/** Componente Columna del footer - Información Categorías */
const ColumnCategories = (): JSX.Element => {

    /** Hook que contiene las dimensiones de la pantalla y maneja los componentes de acuerdo al resultado obtenido  */
    const { width, maxLargeWidth }: ScreenSize = useScreenSize();
    /** Variable que define si es entorno mobile o desktop */
    const isMobile: boolean = width < maxLargeWidth;

    /** Objeto Redux que almacena la data del menu  */
    const navMenu: IMenu[] = useAppSelector((state) => state.mainMenuState);

    /**  Llamado del footer desde el controlador */
    const { footer } = MenuController();

    /**  Estado inicial que trae un arreglo vacío bajo la interface FooterInterface 	*/
    const [footerMenu, setFooterMenu] = useState<IMenu[]>([]);

    const buttonVariant = getCSSVariableValue('--link-button-variant-footer');
    const textVariant = getCSSVariableValue('--show-text-footer-color-variant-light');
    const linkVariantButton = getCSSVariableValue('--icon-variant-light');

    const CATEGORIES_TITLE: string = translate("footer.products_categoy");

    /** UseEffect para renderizado de Footer 	*/
    useLayoutEffect(() => {
        // Recupera el objeto del Footer del controlador
        const footerData: IMenu[] = JSON.parse(JSON.stringify(footer()));

        //Extrae la información de las categorías
        const categoryMenu: IMenu | null = navMenu.find((menu) => menu.slug === translate('breadcrumbs.category')) ?? null;
        const productsMenu: IMenu | null = categoryMenu?.children!.find((menu) => menu.title === 'Productos') ?? null;

        //Arma el objeto de categorías con el titulo necesario en el Footer
        const categoryMenuFooter: IMenu = {
            icon: '',
            id: '',
            title: CATEGORIES_TITLE,
            slug: '',
            url: '',
            children: productsMenu != null ? JSON.parse(JSON.stringify(productsMenu.children)) : [],
        };

        // Agrega las categorías al objeto footer
        footerData.unshift(categoryMenuFooter);

        //Actualiza el state
        setFooterMenu(footerData);
    }, [navMenu]);

    /** Columna Categorías 	*/
    const FooterItem = (menu: IMenu, url: string, index: number): JSX.Element => {
        return (
            <div key={`footer-child-${index + 1}`}>
                {url !== '#' ? (
                    <NavLink to={menu.url} className={textVariant}>
                        <IconList classIcon='pe-2' iconName={menu.icon} classMain={`${buttonVariant} py-2 ${linkVariantButton}`} title={menu.title} />
                    </NavLink>
                ) : (
                    <IconList
                        iconName={menu.icon}
                        classMain={`${buttonVariant} py-2`}
                        title={menu.title}
                        onClick={menu.function}
                    />
                )}
            </div>
        );
    };

    return (
        <>
            {isMobile &&
                footerMenu.map((list, index) => (
                    <div key={`footer-${index + 1}`}>
                        <DropDownList id={list.id} title={CATEGORIES_TITLE} classTitle={`${textVariant} p-large-bold`}>
                            {list.children?.map((child, index) => FooterItem(child, child.url, index))}
                        </DropDownList>
                    </div>
                ))
            }
            {!isMobile &&
                footerMenu.map((list, index) => (
                    <Col xs={3} key={`footer-${index + 1}`}>
                        <ul className={`${textVariant} list-unstyled ${footerMenu.length > 3 || (footerMenu.length % 2 === 0 && 'mx-auto')}`}>
                            <span className='p-large-bold'>{CATEGORIES_TITLE}</span>
                            {list.children?.slice(0, 6).map((list, index) => FooterItem(list, list.url, index))}
                        </ul>
                    </Col>
                ))
            }
        </>
    )
}

export default ColumnCategories;